/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Tab_ChartsInputs */

const en_us2_exercise_sheet_tab_charts = /** @type {(inputs: Exercise_Sheet_Tab_ChartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charts`)
};

const pt_br2_exercise_sheet_tab_charts = /** @type {(inputs: Exercise_Sheet_Tab_ChartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gráficos`)
};

const es_419_exercise_sheet_tab_charts = /** @type {(inputs: Exercise_Sheet_Tab_ChartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gráficas`)
};

const pt_pt2_exercise_sheet_tab_charts = /** @type {(inputs: Exercise_Sheet_Tab_ChartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gráficos`)
};

const fr_fr2_exercise_sheet_tab_charts = /** @type {(inputs: Exercise_Sheet_Tab_ChartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Graphiques`)
};

const de_de2_exercise_sheet_tab_charts = /** @type {(inputs: Exercise_Sheet_Tab_ChartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagramme`)
};

const it_it2_exercise_sheet_tab_charts = /** @type {(inputs: Exercise_Sheet_Tab_ChartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grafici`)
};

/**
* | output |
* | --- |
* | "Charts" |
*
* @param {Exercise_Sheet_Tab_ChartsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_tab_charts = /** @type {((inputs?: Exercise_Sheet_Tab_ChartsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Tab_ChartsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_tab_charts(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_tab_charts(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_tab_charts(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_tab_charts(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_tab_charts(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_tab_charts(inputs)
	return en_us2_exercise_sheet_tab_charts(inputs)
});
export { exercise_sheet_tab_charts as "exercise-sheet.tab_charts" }